import React, { useEffect } from 'react';

interface TwitterEmbedProps {
  username?: string;
  accountId?: string;
}

export const TwitterEmbed: React.FC<TwitterEmbedProps> = ({ 
  username = 'twitter', 
  accountId 
}) => {
  useEffect(() => {
    // Load Twitter widgets script
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://platform.twitter.com/widgets.js"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="w-full">
      <a 
        className="twitter-timeline" 
        data-height="500"
        data-theme="light"
        data-chrome="noheader nofooter noborders transparent"
        href={`https://twitter.com/${username}?ref_src=twsrc%5Etfw`}
      >
        Tweets by @{username}
      </a>
    </div>
  );
};